import { lang } from '@lib/constants'
import type { GetStartedPlansConfig } from '@lib/types'

import allPlansConfig from './get-started-plans.json'

const localeConfig = allPlansConfig as unknown as Record<string, GetStartedPlansConfig>

const config: GetStartedPlansConfig = localeConfig[lang] ?? localeConfig['en-us']

export default config
